import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

import { TransactionDetails, TransactionHistory } from '@shared/models';

import { HistoryItemComponent } from '../history-item/history-item.component';
import { selectRouteParams } from '@store';

@Component({
  selector: 'app-transaction-history',
  templateUrl: 'transaction-history.component.html',
  styleUrls: ['transaction-history.component.scss'],
  imports: [HistoryItemComponent],
  standalone: true,
})
export class TransactionHistoryComponent {
  @ViewChild('contentElementRef') contentElementRef!: ElementRef<HTMLElement>;

  private store = inject(Store);

  @Input() transactionHistoryItems!: TransactionHistory[];

  @Input() loading = true;

  transactionId!: TransactionDetails['id'];

  get firstItemWithSubItems(): string | undefined {
    return this.transactionHistoryItems?.find((item) => item.parentTransactionId)?.id;
  }

  constructor() {
    this.store
      .select(selectRouteParams)
      .pipe(
        takeUntilDestroyed(),
        map((params) => params['transactionId']),
        filter(Boolean),
      )
      .subscribe((transactionId) => {
        this.transactionId = transactionId;
      });
  }
}
